export default __webpack_public_path__ + "static/media/undraw_empty_xct9.0523db65.svg";